import { ENV } from '../config/environment';
import { authenticatedFetch } from '../utils/authenticatedFetch';

/**
 * 💳 WINGMAN PAYMENT SERVICE (Frontend)
 * MISSION: Manage Stripe checkout sessions and tier upgrades.
 */

const GATEWAY_URL = ENV.GATEWAY_URL;

export class PaymentService {
    /**
     * Fetch Stripe configuration (Price IDs and Publishable Key)
     */
    public static async getConfig() {
        const response = await authenticatedFetch(`${GATEWAY_URL}/payments/config`);
        return response.json();
    }

    /**
     * Initiate a Stripe Checkout session
     */
    public static async createCheckoutSession(params: {
        customerEmail: string;
        priceId: string;
        userId: string;
        customerId?: string;
        firebaseUid?: string;
        successUrl?: string;
        cancelUrl?: string;
    }) {
        console.log(`[PAYMENT] Initiating checkout for ${params.customerEmail} (${params.priceId})`);
        
        // Create checkout session via backend
        const response = await authenticatedFetch(`${GATEWAY_URL}/payments/create-checkout-session`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                priceId: params.priceId,
                customerId: params.customerId,
                customerEmail: params.customerEmail,
                firebaseUid: params.firebaseUid,
                successUrl: params.successUrl || `${window.location.origin}/payment-success`,
                cancelUrl: params.cancelUrl || `${window.location.origin}/payment-cancel`
            }),
        });

        const data = await response.json();
        
        if (data.url) {
            console.log(`[PAYMENT] Redirecting to Stripe: ${data.url}`);
            window.location.href = data.url; // Redirect to Stripe Hosted Checkout
        } else {
            throw new Error(data.error || 'Failed to create checkout session');
        }
    }

    /**
     * Sync user tier from backend
     */
    public static async syncUserTier(userId: string): Promise<string> {
        // Fetch current tier from backend
        const response = await authenticatedFetch(`${GATEWAY_URL}/payments/user-tier/${userId}`);
        const data = await response.json();
        return data.tier || 'free';
    }
}
